<template>
  <div id="resumo-proposta">
    <v-row>
      <v-col cols="12" class="py-0 grey--text text--darken-3 font-weight-medium">
        <resumo-cliente-dados-gerais :model="model"></resumo-cliente-dados-gerais>
        <br/>
        <template class="text-center">
            <div id='creditoSimples-timeline' class="text-left" >

              <div class="d-flex">
                <div class="d-flex flex-column mb-0 pb-0 text-left">
                <v-timeline :id="i === 6?'finalTimeline':''" v-for="(item, i) in detalhamento" :key="i"
                  dense
                  align-top
                  class='pt-0 pb-0'
                  >
                  <v-timeline-item
                  id='creditoSimples-dot'
                  color="primary"
                  class="pb-0"
                >
                <v-row class="pl-0">
                  <v-col class='pt-0 pl-0'>
                    <p class="text-caption font-weight-medium">
                      {{ item.title }}
                    </p>
                    <p class="text-subtitle-1 font-weight-medium">
                      {{ item.body }}
                    </p>
                    <p class="text-caption font-weight-medium">
                      {{ item.footer }}
                    </p>
                  </v-col>
                </v-row>
                </v-timeline-item>
              </v-timeline>
              </div>
              </div>
            </div>
        </template>
      </v-col>
    </v-row>
  </div>
</template>
<script>
export default {
  props: {
    modal: { type: Boolean, default: false },
    model: { type: Object }
  },
  data () {
    return {
      isLoaded: false,
    };
  },
  computed: {
    detalhamento () {
      if (!this.model) { return [] }
      return [
        {
          icon: require('assets/icons/timelineIcon.svg'),
          title: 'Valor Desejado',
          body: this.$api.UI.Format.Currency(this.model.VlrSolicitado)
        },
        {
          icon: require('assets/icons/timelineIcon.svg'),
          title: 'Valor do IOF',
          body: this.$api.UI.Format.Currency(this.model.VlrIOF)
        },
        {
          icon: require('assets/icons/timelineIcon.svg'),
          title: 'Valor Financiado',
          body: this.$api.UI.Format.Currency(this.model.VlrTotalCredito),
          footer: this.$api.UI.Format.Decimal(this.model.VlrTotalCredito * (100 / this.model.VlrTotalCredito)) + '% do valor financiado',
        },
        {
          icon: require('assets/icons/timelineIcon.svg'),
          title: 'Valor do Juros',
          body: this.$api.UI.Format.Currency(this.model.VlrTotalDivida - this.model.VlrTotalCredito),
          footer: `${this.$api.UI.Format.Decimal(this.model.PercJurosMensal)}% a.m. / ${this.$api.UI.Format.Decimal(this.model.PercJurosAnual)}% a.a.`,
        },
        {
          icon: require('assets/icons/timelineIcon.svg'),
          title: 'Valor total a pagar',
          body: this.$api.UI.Format.Currency(this.model.VlrTotalDivida),
          footer: `R$ ${this.$api.UI.Format.Decimal(this.model.PercCETMensal)}% a.m. / ${this.$api.UI.Format.Decimal(this.model.PercCETAnual)} ao ano`
        },
        {
          icon: require('assets/icons/timelineIcon.svg'),
          title: 'Forma de pagamento',
          body: `${this.model.QtdeParcelas} ${this.model.QtdeParcelas === 1 ? 'parcela' : 'parcelas'} de R$ ${this.$api.UI.Format.Decimal(this.model.VlrParcelaCalculado)}`
        },
        {
          icon: require('assets/icons/timelineIcon.svg'),
          title: 'Data do primeiro vencimento',
          body: `${this.$api.UI.Format.Date(this.model.DtPrimeiroVencto, 'dd \'de\' MMMM yyyy')}`
        },
      ]
    }
  },
  methods: {
    load (model) {
      this.$api.UTIL.Functions.SetAllButNull(this, this, 'model', model);
      this.isLoaded = true;
    },
  },
};
</script>

<style>
#resumo-proposta span.text-label {
  display: block;
  font-weight: 400;
}

#resumo-proposta span.text-h5 {
  font-weight: 400;
}

#resumo-proposta div.item-value {
  padding-bottom: 2px;
  padding-top: 2px;
  padding-left: 12px;
  padding-right: 12px;
  display: flex;
  justify-content: space-between;
}

#resumo-proposta span.text-value-label,
#resumo-proposta span.text-subtitle-1 {
  font-weight: 400;
}

#resumo-proposta span.text-value {
  text-align: end;
}
</style>
